__webpack_require__.p = "/ui/v2/";